import { forwardRef } from "react";
import { LoaderCircle } from "lucide-react";
import { cn } from "@/utils";
import { buttonVariants, loadingSpinner } from "./Button.styles";
import type { ButtonProps } from "./Button.types";

/**
 * Button — primitive CTA. Variants/sizes/states defined in Button.styles
 * via CVA so prop combinations are type-checked at the call site.
 */
const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      size,
      variant,
      startIcon,
      endIcon,
      isLoading = false,
      loadingText,
      fullWidth,
      className,
      disabled,
      ...props
    },
    ref
  ) => {
    const isDisabled = disabled || isLoading;

    return (
      <button
        ref={ref}
        className={cn(buttonVariants({ variant, size, fullWidth }), className)}
        disabled={isDisabled}
        {...props}
      >
        {isLoading && <LoaderCircle className={loadingSpinner} />}
        {!isLoading && startIcon && (
          <span className="flex items-center">{startIcon}</span>
        )}
        {isLoading && loadingText ? loadingText : children}
        {!isLoading && endIcon && (
          <span className="flex items-center">{endIcon}</span>
        )}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
